import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import BigCar_3d from "../../../../../media/images/icons/bigcar-3d.png";
import chargWallet from "../../../../../media/images/icons/chargWallet.png";
import goldShare from "../../../../../media/images/icons/goldShare.png";
import pinkwallet from "../../../../../media/images/icons/pinkwallet.png";
import { Link } from "react-router-dom";

interface Props {
  activeTab: number;
  getTabIndex: (tabIndex: number) => void;
}
export default function WalletActionBox({ getTabIndex, activeTab }: Props) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mx: 4,
        mt: 2,
        gap: "8px",
      }}
    >
      <Box
        onClick={() => getTabIndex(1)}
        sx={{
          maxWidth: "110px",
          backgroundImage: `url(${chargWallet})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "80px -10px",
          flex: "1",
          overflow: "hidden",
          borderRadius: "8px",
          paddingLeft: "8px",
          paddingRight: "35px",
          width: "fit-content",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor:
            activeTab === 1
              ? theme.palette.secondary.main
              : theme.palette.primary.main,
        }}
      >
        <Typography
          sx={{
            my: 1,
            color: "#fff",
          }}
        >
          افزایش موجودی
        </Typography>
      </Box>
      <Box
        onClick={() => getTabIndex(2)}
        sx={{
          maxWidth: "110px",

          backgroundImage: `url(${goldShare})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "80px -10px",
          flex: "1",
          overflow: "hidden",
          borderRadius: "8px",
          paddingLeft: "8px",
          paddingRight: "35px",
          width: "fit-content",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor:
            activeTab === 2
              ? theme.palette.secondary.main
              : theme.palette.primary.main,
        }}
      >
        <Typography
          sx={{
            my: 1,
            color: "#fff",
          }}
        >
          ارتقا اشتراک
        </Typography>
      </Box>
      <Link
        to={"/driver/withdraw-wallet"}
        // onClick={() => getTabIndex(3)}
        style={{
          maxWidth: "110px",
          backgroundImage: `url(${pinkwallet})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "80px 10px",
          flex: "1",
          overflow: "hidden",
          borderRadius: "8px",
          paddingLeft: "8px",
          paddingRight: "35px",
          width: "fit-content",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor:
            activeTab === 3
              ? theme.palette.secondary.main
              : theme.palette.primary.main,
        }}
      >
        <Typography
          sx={{
            my: 1,
            color: "#fff",
          }}
        >
          درخواست برداشت
        </Typography>
      </Link>
    </Box>
  );
}
